import { MutationTree } from 'vuex'
import { FeatureFlagsState, Flags } from '@/@types'

const mutations: MutationTree<FeatureFlagsState> = {
  FEATURE_FLAGS_UPDATED: (state, flags: Flags) => {
    state.flags = flags
  },
}

export default mutations
